import React from 'react'
import {FaExclamationTriangle as Warning} from 'react-icons/fa'
import {MdCheckCircle as Success, MdError as Danger, MdInfo as Info} from 'react-icons/md'
import PropTypes from 'prop-types'

function Icon(props) {
  const {show, type, className} = props

  if (!show) return null

  switch (type) {
    case 'success':
      return <Success size="22" className={className} />
    case 'warning':
      return <Warning size="19" className={className} />
    case 'danger':
      return <Danger size="22" className={className} />
    default:
      return <Info size="22" className={className} />
  }
}

Icon.propTypes = {
  type: PropTypes.string,
  show: PropTypes.bool,
  className: PropTypes.string
}

export default Icon
